const HIDDEN_CLASS = 'product__slide--option-hidden';

const syncThumbs = (root) => {
  root.querySelectorAll('[data-option-media]').forEach((slide) => {
    const hidden = slide.classList.contains(HIDDEN_CLASS);
    root.querySelectorAll(`[data-thumb-link][data-media-id="${slide.dataset.mediaId}"]`).forEach((link) => {
      link.closest('[data-thumb-item]')?.classList.toggle(HIDDEN_CLASS, hidden);
    });
  });
};

const matchesOption = (key, value) => key === value || key.endsWith(` ${value}`) || value.endsWith(` ${key}`);

const filterOptionMedia = (root, variant) => {
  const values = variant.options.filter(Boolean).map((value) => value.toLowerCase());
  const featuredId = String(variant.featured_media?.id ?? '');

  root.querySelectorAll('[data-option-media]').forEach((slide) => {
    const key = slide.dataset.optionMedia.toLowerCase();
    const matches = slide.dataset.imageId === featuredId || values.some((value) => matchesOption(key, value));
    slide.classList.toggle(HIDDEN_CLASS, !matches);
  });

  syncThumbs(root);
};

document.querySelectorAll('product-images').forEach(syncThumbs);

if (window.subscribe && window.theme?.PUB_SUB_EVENTS) {
  window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data?.variant?.options) return;

    const section = document.getElementById(`shopify-section-${data.sectionId}`) || document;
    section.querySelectorAll('product-images').forEach((root) => filterOptionMedia(root, data.variant));
  });
}
